import { render } from "./DescList.vue?vue&type=template&id=b854fdf8&scoped=true"
import script from "./DescList.vue?vue&type=script&lang=js"
export * from "./DescList.vue?vue&type=script&lang=js"

import "./DescList.vue?vue&type=style&index=0&id=b854fdf8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b854fdf8"]])

export default __exports__